import { useMemo } from "react";
import { useLocation, Link } from "react-router-dom";

import { t } from "../../services";
import { pathsConfig } from "./config";

import WrapperContainer from "../Containers/WrapperContainer";
import FlexContainers from "../Containers/FlexContainers";
import { RouteLink } from "./styled";

const Breadcrumbs = () => {
  const location = useLocation();

  const paths = useMemo(() => {
    const result = [];
    const pathParts = location.pathname.split("/");

    const paths = pathParts
      .map((path, index) => {
        let res = "";
        for (let i = 0; i < index; i++) {
          res += pathParts[i] + "/";
        }

        res += path;

        return res;
      })
      .filter((path) => path !== location.pathname);

    paths.forEach((path) => {
      const config = pathsConfig.find((config) => config.path === path);
      if (config) {
        result.push(config);
      }
    });

    return result;
  }, [location]);

  return (
    <WrapperContainer Container={FlexContainers.FlexRowStart} width={"100%"}>
      {paths.map((pathConfig) => (
        <WrapperContainer key={pathConfig.id}>
          <RouteLink as={Link} to={pathConfig.path} active={location.pathname === pathConfig.path}>
            {t(pathConfig.title)}
          </RouteLink>
        </WrapperContainer>
      ))}
    </WrapperContainer>
  );
};

export default Breadcrumbs;
